import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RmaIconComponent } from '@rma/generic/ui/icon';

/**
 * The right-edge scroll chevron shared by the profile-card carousels. Pairs with
 * OverflowScrollDirective: bind [canScroll] to its signal and (scrolled) to scrollRight().
 */
@Component({
  selector: 'rma-scroll-chevron',
  imports: [RmaIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (canScroll()) {
      <button
        type="button"
        class="absolute top-1/2 right-0 z-10 flex h-11 w-6 -translate-y-1/2 items-center justify-center rounded-l-full bg-white shadow-[0_4px_10px_-2px_rgba(12,26,75,0.15)] print:hidden"
        [attr.aria-label]="label()"
        (click)="scrolled.emit()"
      >
        <rma-icon class="text-steel-50" glyph="chevron_right" size="small" />
      </button>
    }
  `,
})
export class ScrollChevronComponent {
  public readonly canScroll = input(false);
  public readonly label = input('');
  public readonly scrolled = output<void>();
}
